export const MODULE_CLASS_NAME = 'TaskManagerModule';

export enum ViewNames {
    TASK_REPORTING_VIEW = 'kta20-task-reporting-view',
    TASK_FORM_VIEW = 'kta20-task-form-view',
    TASK_CLOSURE_FORM_VIEW = 'kta20-task-closure-form-view'
}

export const ALLOWED_STRING_SPECIAL_CHARS = [' ','!','?','.',',','-'];